<section class="find-dealer-page container-fluid">
    <div class="row breadcrumb-wrapper">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="content-heading d-flex align-items-center justify-content-between mb-4 mt-4">
            <h1 class="page-sub-title cv-text-dark">Dealer Outlet Locator</h1>
        </div>
        <form [formGroup]="dealerLocaterForm">

            <div class="row gx-5 mb-3">

                <div class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 col-xxl-4">
                    <p class="location-option-label" *ngIf="!this.isShowLocationSearch">Select location</p>
                    <div class="row gx-3" *ngIf="!this.isShowLocationSearch">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4">
                            <select class="form-select height48" formControlName="state" (change)="getCity()">
                                <option value="0" selected disabled>Select State</option>
                                <option *ngFor="let state of stateList" value="{{ [state.name , state.code] }}">
                                    {{ state.name | titlecase }}
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-3">
                            <select class="form-select height48" id="checkout-district"
                                formControlName="district" (change)="findDealerChange()">
                                <option value="0" selected disabled>Select District</option>
                                <option *ngFor="let district of districtList" value="{{ district }}">
                                    {{ district | titlecase }}
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 ">
                            <button class="btn btn-primary btn-lg btn-grad-primary btn-brand ps-4 pe-4 h-56 fs-6"
                            (click)="findDealerData()" [disabled]="hideSearch" data-toggle="tooltip" data-placement="top" title="Click here to Search Dealer Locations">Search Dealer Locations</button>                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 d-flex align-items-center" *ngIf="isShowLocationSearch">
                            <a class="d-inline-block cursor" (click)="backToSearch()">
                                <img [src]="environment1 + 'images/new-images/leftarrowDarkblue.svg'" alt="left arrow Darkblue" loading="lazy">
                            </a>
                            <p class="d-inline-block ms-3 mb-0 total-count">
                                {{countDisplay}} Result found
                            </p>
                            <div class="ms-auto map-list-swicher d-md-none">
                                <a (click)="activeView = 'map'" [class.active]="activeView === 'map'"
                                    href="javascript:void(0);">Map</a>
                                <a (click)="activeView = 'list'" [class.active]="activeView === 'list'"
                                    href="javascript:void(0);">List</a>
                            </div>
                        </div>
                        <div class="col-12 dealer-search-list mt-4" *ngIf="activeView === 'list' && isMobile">
                            <ul>
                                <li class="d-flex align-items-start" *ngFor="let data of division"
                                    class="padding16">
                                    <span class="dealer-shop-image d-inline-flex">
                                        <img class="img-fluid" *ngIf="!data?.image_path" alt="defaultImg"
                                            [src]='environment1 + "assets/images/defaultImg.png"' loading="lazy"/>
                                        <img class="img-fluid" *ngIf="data?.image_path" alt="dealer_image"
                                            src="{{ data?.image_path }}" loading="lazy"/>
                                    </span>
                                    <span class="dealer-desc d-inline-block">
                                        <h4 class="dealer-name cursor"
                                            (click)="getDirection(data?.id,data?.latitude,data?.longitude)">{{
                                            data?.brand_name }} </h4>
                                        <p class="dealer-address">{{ data?.org_add_1 + ','}} {{ data?.org_add_2 +
                                            (data?.org_add_2 ? ',':'')}} {{ data?.locality + (data?.locality ? ',' :
                                            '')}} {{ data?.landmark + (data?.landmark ? ',' :'')}} {{ data?.org_city }}
                                            {{ data?.pincode ? (' - ' + data?.pincode) : '' }} </p>
                                        <ul>
                                            <li *ngIf="data?.timing" class="dealer-timing pl-0"
                                                class="timing">{{ data?.timing }}</li>
                                            <li *ngIf="data?.mobile_number" class="dealer-contact pl-0"><a
                                                    [href]="getNumber(data?.mobile_number)">{{ data?.mobile_number
                                                    }}</a></li>
                                        </ul>
                                        <p class="dealer-rating" *ngIf="data?.rating">
                                            <img alt="rating" [src]='environment1 + "assets/images/Star.svg"' loading="lazy" alt="Star"/> <span>{{ data?.rating
                                                }}</span> <span>({{ data?.rating_count }})</span>
                                        </p>
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="col-12 dealer-search-list mt-4" *ngIf="!isMobile">
                            <ul>
                                <li class="d-flex align-items-start" *ngFor="let data of division"
                                    class="padding16">
                                    <span class="dealer-shop-image d-inline-flex">
                                        <img class="img-fluid" *ngIf="!data?.image_path" alt="defaultImg"
                                            [src]='environment1 + "assets/images/defaultImg.png"' loading="lazy"/>
                                        <img class="img-fluid" *ngIf="data?.image_path" alt="dealerImg"
                                            src="{{ data?.image_path }}" loading="lazy"/>
                                    </span>
                                    <span class="dealer-desc d-inline-block">
                                        <h4 class="dealer-name cursor"
                                            (click)="getDirection(data?.id,data?.latitude,data?.longitude)">{{
                                            data?.brand_name }} </h4>
                                        <p class="dealer-address">{{ data?.org_add_1 + ','}} {{ data?.org_add_2 +
                                            (data?.org_add_2 ? ',':'')}} {{ data?.locality + (data?.locality ? ',' :
                                            '')}} {{ data?.landmark + (data?.landmark ? ',' :'')}} {{ data?.org_city }}
                                            {{ data?.pincode ? (' - ' + data?.pincode) : '' }} </p>
                                        <ul>
                                            <li *ngIf="data?.timing" class="dealer-timing pl-0"
                                            class="timing">{{ data?.timing }}</li>
                                            <li *ngIf="data?.mobile_number" class="dealer-contact pl-0"><a
                                                    [href]="getNumber(data?.mobile_number)">{{ data?.mobile_number
                                                    }}</a></li>
                                        </ul>
                                        <p class="dealer-rating" *ngIf="data?.rating">
                                            <img alt="rating" [src]='environment1 + "assets/images/Star.svg"' loading="lazy" alt="Star"/> <span>{{ data?.rating
                                                }}</span> <span>({{ data?.rating_count }})</span>
                                        </p>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-7 col-lg-8 col-xl-8 col-xxl-8 d-md-block"
                    *ngIf="!isMobile && countDisplay">
                    <agm-map [latitude]="centerLat" [longitude]="centerLng" [zoom]="zoom" *ngIf="maker"
                        [restriction]="countryRestriction" [ngStyle]="{ height: '582px' }">
                        <agm-marker *ngFor="let data of divisions; let i = index" [latitude]="data.latitude"
                            [longitude]="data.longitude" (markerClick)="openWindow(data.id)">
                            <agm-info-window class="width300" (infoWindowClose)="close()" [disableAutoPan]="false"
                                [isOpen]="isInfoWindowOpen(data.id)" #infoWindow>
                                <div class="content" class="width300">
                                    <span class="dealer-shop-image">
                                        <img class="width300" *ngIf="!data?.image_path" alt="defaultImg"
                                            [src]='environment1 + "assets/images/defaultImg.png"' loading="lazy"/>
                                        <img class="width300" *ngIf="data?.image_path" alt="dealerImg"
                                            src="{{ data?.image_path }}" loading="lazy"/>
                                    </span>
                                    <div>{{ data?.brand_name}}- {{ data?.locality}}</div>
                                    <div class="marker">
                                        {{data?.org_add_1 | titlecase}}
                                        {{data?.org_add_2 | titlecase}}
                                        {{data?.org_district | titlecase}}
                                        {{data?.state_name | titlecase}}
                                        {{data?.pincode}}
                                    </div>
                                    <ul>
                                        <li *ngIf="data?.timing" class="dealer-timing">{{ data?.timing }}</li>
                                        <li *ngIf="data?.mobile_number" class="dealer-contact"><a
                                                [href]="getNumber(data?.mobile_number)">{{ data?.mobile_number }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </agm-info-window>


                        </agm-marker>
                    </agm-map>
                </div>
                <div class="col-12 col-sm-12 col-md-7 col-lg-8 col-xl-8 col-xxl-8 d-md-block"
                    *ngIf="activeView === 'map' && isMobile">
                    <agm-map [latitude]="centerLat" [longitude]="centerLng" [zoom]="zoom" *ngIf="maker"
                        [restriction]="countryRestriction" [ngStyle]="{ height: '582px' }">
                        <agm-marker *ngFor="let data of divisions; let i = index" [latitude]="data.latitude"
                            [longitude]="data.longitude" (markerClick)="openWindow(data.id)">
                            <agm-info-window class="width300" (infoWindowClose)="close()" [disableAutoPan]="false"
                                [isOpen]="isInfoWindowOpen(data.id)" #infoWindow>
                                <div class="content" class="width300">
                                    <span class="dealer-shop-image">
                                        <img class="width300" *ngIf="!data?.image_path" alt="defaultImg"
                                            [src]='environment1 + "assets/images/defaultImg.png"' loading="lazy"/>
                                        <img class="width300" *ngIf="data?.image_path" alt="dealerImg"
                                            src="{{ data?.image_path }}" loading="lazy"/>
                                    </span>
                                    <div>{{ data?.brand_name}}- {{ data?.locality}}</div>
                                    <div class="marker">
                                        {{data?.org_add_1 | titlecase}}
                                        {{data?.org_add_2 | titlecase}}
                                        {{data?.org_district | titlecase}}
                                        {{data?.state_name | titlecase}}
                                        {{data?.pincode}}
                                    </div>
                                    <ul>
                                        <li *ngIf="data?.timing" class="dealer-timing">{{ data?.timing }}</li>
                                        <li *ngIf="data?.mobile_number" class="dealer-contact"><a
                                                [href]="getNumber(data?.mobile_number)">{{ data?.mobile_number }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </agm-info-window>


                        </agm-marker>
                    </agm-map>
                </div>
            </div>
        </form>
    </div>
</section>
